<template>
    <section class="patients-container">
        <div class="patient-filters">
            <CommonFilters :filtersChanged="getPatientsList" />
            <ScrollPagination
                :page-number="pageNumber"
                v-on:pageNumberUpdate="pageNumberUpdated"
                class="h-100 overflow-hidden"
            >
                <section
                    :class="`ps-2 pt-2 bg-white d-flex flex-column patients-list pe-1 scroll-paginate  ${userOs == 'Windows' ? 'custom-scrollbar' : ''}`"
                >
                    <div v-if="!patientsList.length && !showLoading" class="patients-list pe-1">No patients found</div>
                    <div
                        :class="`patient-card mb-2 ${selectedPatient.Id === patient.Id ? 'selected' : ''}`"
                        v-for="patient of patientsList"
                        :key="patient.Id"
                        @click="selectPatient(patient)"
                    >
                        <div class="xd-flex flex-column align-items-center justify-content-between">
                            <ProductPill class="me-2" :product-id="getApplicationId(patient.Application)" />
                            <div class="fw-bold">
                                {{
                                    formatName(patient.FirstName, patient.LastName, "LN, FN", "", patient.MiddleInitial)
                                }}
                            </div>
                            <div>{{ patient.Mrn }}</div>
                        </div>
                    </div>
                    <div class="text-center py-2" ref="trigger" v-if="showLoading">
                        <i class="fas fa-spinner fa-pulse fa-fw fa-2x"></i>
                        <div>Loading...</div>
                    </div>
                </section>
            </ScrollPagination>
        </div>
        <div class="patient-details-container" v-if="!loading && selectedPatientDetails">
            <HosPalPatientDetails
                v-if="
                    patientApplication === ApplicationEnum.AxxessHospiceFE ||
                    patientApplication === ApplicationEnum.AxxessPalliative
                "
                :selectedPatientDetails="selectedPatientDetails"
                :patientId="selectedPatient.Id"
                :agencyId="selectedPatient.AgencyId"
                :application="selectedPatient.Application"
            />
            <HHPatientDetails
                v-if="patientApplication === ApplicationEnum.AgencyCore"
                :selectedPatientDetails="selectedPatientDetails.Patient"
                :patientRiskDetails="selectedPatientDetails.PatientRiskDetails"
                :patientTags="selectedPatientDetails.PatientTags"
                :patientDetails="selectedPatientDetails"
                :patientId="selectedPatient.Id"
                :agencyId="selectedPatient.AgencyId"
                :application="patientApplication"
            />
            <HCPatientDetails
                v-if="patientApplication === ApplicationEnum.HomeCare"
                :selectedPatientDetails="selectedPatientDetails"
                :patientId="selectedPatient.Id"
                :agencyId="selectedPatient.AgencyId"
                :application="patientApplication"
            />
        </div>
    </section>
</template>

<style src="./PatientCharts.scss"></style>
<script lang="ts" src="./PatientCharts.ts"></script>
